export default class Form {
    constructor(params, clear_on_success = true) {
        this.original_fields = params;
        this.processing = false;
        this.errors = new Errors();
        this.clear_on_success = clear_on_success;

        for (let field in params) {
            this[field] = params[field];
        }
    }

    getData() {
        let data = new FormData();

        for (let field in this.original_fields) {
            data.append(field, this[field]);
        }

        return data;
    }

    add(name, value) {
        this.original_fields[name] = value;
    }

    clear() {
        for (let field in this.original_fields) {
            this[field] = '';
        }
    }

    get(url, data) {
        return this.request('get', url);
    }

    post(url, data) {
        return this.request('post', url);
    }

    delete(url, data) {
        return this.request('delete', url);
    }

    request(type, url) {
        return new Promise((resolve, reject) => {
            this.processing = true;

            axios[type](url, this.getData()).then(response => {
                if (this.clear_on_success) this.clear();
                resolve(response);
            }).catch(error => {
                if (error.response && error.response.data) {
                    this.errors.record(error.response.data.errors);
                }
                reject(error);
            }).finally(() => {
                setTimeout(() => {
                    this.processing = false;
                }, 150);
            });
        });
    }
}

class Errors {
    constructor() {
        this.errors = {};
    }

    has(field) {
        if (!this.errors) {
            return false;
        }

        return this.errors.hasOwnProperty(field);
    }

    get(field) {
        if (this.errors[field]) {
            return this.errors[field][0];
        }
    }

    record(errors) {
        this.errors = errors;
    }

    clear(field) {
        this.errors = {...this.errors};
        delete this.errors[field];
    }

    hasAny() {
        return Object.keys(this.errors).length;
    }
}
